import React from 'react';

const HomeUser2 = props => {



    return (
        <div></div>
    )
}

export default HomeUser2